// Debug-only component: gated behind ?scanIntoStore=true URL parameter

import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Button from '@amzn/meridian/button'
import { getStoreId, getSelectedStoreId, getStoreScanStatus } from '@atredux/selectors/storeSelector'
import { setStoreScanStatus, setSelectedStoreId } from '@atredux/slices/storeSlice'
import { RootState } from '@atredux/store'
import { hasUserScannedIntoStore } from '@api/MockStoreScanAPI'
import * as StoreService from '@services/StoreService'
import './DebugStoreScanButton.scss'

/**
 * Debug button that calls mock API to simulate store scan.
 * Only appears on Associate Entry Tool when ?scanIntoStore=true URL param is set.
 */
export const DebugStoreScanButton: React.FC = () => {
    const dispatch = useDispatch()
    const currentStoreId = useSelector(getStoreId)
    const selectedStoreId = useSelector(getSelectedStoreId)
    const isCurrentScanned = useSelector((state: RootState) => currentStoreId ? getStoreScanStatus(state, currentStoreId) : false)
    const [isLoading, setIsLoading] = useState(false)

    const handleScan = async () => {
        const storeToScan = selectedStoreId || currentStoreId
        if (!storeToScan) return

        setIsLoading(true)
        try {
            const result = await hasUserScannedIntoStore()
            dispatch(setStoreScanStatus({ storeId: storeToScan, scanned: result }))

            await StoreService.setCurrentStore(storeToScan)
            dispatch(setSelectedStoreId(undefined))
            console.log(`Debug: Store scan completed and current store set for ${storeToScan}`)
        } catch (error) {
            console.error('Debug: Store scan failed:', error)
        } finally {
            setIsLoading(false)
        }
    }

    if ((!selectedStoreId && !currentStoreId) || (currentStoreId && isCurrentScanned && !selectedStoreId)) {
        return null
    }

    return (
        <div className="debug-store-scan-button-container">
            <Button
                onClick={handleScan}
                disabled={isLoading}
                size="small"
                data-atb-id="debug-store-scan-button"
            >
                {isLoading ? 'Scanning...' : 'Scan into the store'}
            </Button>
        </div>
    )
}
